module.exports = __webpack_public_path__ + "img/08-4IDMS.b310e2eb.png";